import backofficeAdjustDailyExerciseData from './BackofficeAdjustDailyExerciseData/BackofficeAdjustDailyExerciseData.gql'

const backofficeAdjustDailyExercise = {
  mutation: {
    backofficeAdjustDailyExerciseData,
  },
}

export default backofficeAdjustDailyExercise
